module.exports = __webpack_public_path__ + "static/ozoh-99390b098e6d9a5e281f3e5f0b27de12.png";